import { z } from 'zod';
import type {
  LithostratAgePartsFragment,
  PaleoMapPartsFragment,
} from '~/apollo/generated/v4/graphql';
import { LifecycleStatus } from '~/apollo/generated/v4/graphql';
import type { AgeFormValues } from '~/utils/modules/lithostrat-age-v4';
import { ageSchema, initialAge } from '~/utils/modules/lithostrat-age-v4';
import { ppStringOrNull } from '~/utils/zod';

export const paleoMapSchema = z.object({
  description: z.preprocess(ppStringOrNull, z.string().nullable()),
  lifecycleStatus: z.nativeEnum(LifecycleStatus),
  age: ageSchema,
});

export type PaleoMapFormValues = {
  description: string;
  lifecycleStatus: LifecycleStatus;
  age: AgeFormValues;
};

export function initialPaleoMap(
  paleoMap?: PaleoMapPartsFragment & { age?: LithostratAgePartsFragment },
) {
  return {
    description: paleoMap?.description ?? '',
    lifecycleStatus: paleoMap?.lifecycleStatus ?? LifecycleStatus.Draft,
    age: initialAge(paleoMap?.age),
  };
}
